/* eslint-disable @typescript-eslint/no-explicit-any */
import { alphabetGenerator } from 'utillities/alphabet-utilities';
import { EQUITY_ALLOCATION_SUMMARY_ALIAS, TABLE_SECOND_TITLE, TABLE_TITLE } from './rowConfig';

export default async ({ columns, rowConfig }: any) => {
  let cells = {};
  const alphabet = alphabetGenerator([], columns.length);

  rowConfig.forEach((row: any, rowIdx: any) => {
    columns.forEach((col: any, colIdx: any) => {
      const rowNumber = rowIdx + 1;
      const columnLegend = alphabet[colIdx];
      const key = columnLegend + rowNumber;
      let value = rowNumber === 1 || row.alias === TABLE_TITLE ? TABLE_SECOND_TITLE : col[row.alias];

      if (row.alias === EQUITY_ALLOCATION_SUMMARY_ALIAS) {
        value = '';
      }

      cells = {
        ...cells,
        [key]: {
          ...row,
          key,
          rowSpan: 1,
          columnLegend,
          value,
        },
      };
    });
  });

  return cells;
};
